import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import React, { useContext, useEffect, useState } from 'react';
import { Grid, Paper } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { useForm } from '../../components/hooks/useForm';
import Cookies from 'universal-cookie';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ZoomAni from '@mui/material/Zoom';
import { useSearchParams, Link } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import logo from '../../assets/images/conhecta_logo.svg';
import { Context, UserContext } from '../../context/context';
import fondo from '../../assets/images/Medicos.jpg';
import toast from 'react-hot-toast';
import { GetDescripcionMensaje } from '../../helpers/tools';
import ErrorDialog from './../../components/ErrorDialog';
import config from '../../config';
import TerminoAccept from '../Menu/Header/components/TerminoAccept';
import { useDispatch } from 'react-redux';
import { set } from '../../store/slices/language';
import { useTranslation } from 'react-i18next';

function LoginView() {
  // const { language } = useSelector( state => state.language );
  const language = "es";
  const dispatch = useDispatch();

  const cambiarIdioma = (event) => {
    dispatch(set(event.target.value));
  };

  const [textoTermino, setTextoTermino] = React.useState("");
  const [idtermino, setIdtermino] = React.useState("0");
  const [open, setOpen] = React.useState(false);
  const [terminoFirmado, setTerminoFirmado] = React.useState(false);

  const { t } = useTranslation();

  let mailUsuario;
  let fechaCaducidadClave;
  const diasCaducidadClave = config.diasCaducidadClave;
  const SITE_KEY = "6LfF9G0hAAAAAFM28HVcb_SBUziY62eUUQEB7Wjq";
  const cookies = new Cookies();
  const [context, setContext] = useContext(Context);
  const { user, setUser } = useContext(UserContext);
  const [ipClient, setIpClient] = useState('');
  const [pcClient, setPcClient] = useState('');
  const [latitud, setLatitud] = useState('');
  const [longitud, setLongitud] = useState('');

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  useEffect(() => {
    if (terminoFirmado) {
      let urlSig = '/menu';
      // usuario ROBOT ingresa directamente a documentos
      if (parseInt(sessionStorage.getItem('idUsuario'), 10) === 1827) {
        setContext("false");
        urlSig = '/documentos';
      }
      window.location.href = urlSig;
    }
  }, [terminoFirmado]);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json').
      then((results) => results.json()).
      then((data) => setIpClient(data.ip)).
      catch((e) => console.log(e));

    cargarGeolocalizacion();

    sessionStorage.clear();

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
    });
  }, []);

  const ValidateRecaptchaAndLogin = () => {
    window?.grecaptcha?.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'signup' }).then((token) => {
        Login(token);
      });
    });
    return true;
  };  

  const QLogin = gql`
    query QLogin($usuario: String!, $clave: String!, $token: String!, $ipUsuario: String!, $pcUsuario: String!, $longitud: String!, $latitud: String!){
        login (request: {
            usuario: $usuario,
            password: $clave,
            token: $token,
            ipUsuario: $ipUsuario,
            pcUsuario: $pcUsuario,
            longitud: $longitud,
            latitud: $latitud
            }) {
            success,
            error,
            valorEsperado {
                valido,
                token,
                tokenValidTo,
                usuario {
                    idUsuario,
                    apellido,
                    nombre,
                    email,
                    usuario,
                    idDelegacion,
                    imagenPerfil,
                    imagenPerfilDecode,
                    contentType,
                    fechaCaducidadClave,
                    presetActivo,
                    idTipoUsuario,
                    idTermino,
                    terminoFirmado,
                    terminoTexto                
                }
            }
        }
    }`;
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  const [getUsuario, { loading, error: errorLogin, data: dataLogin }] = useLazyQuery(QLogin);

  const paperStyle = {
    padding: 25,
    paddingTop: 30,
    height: 326,
    width: 302,
    margin: "20px auto",
    borderRadius: 20

  };
  //backgroundColor: "rgba(0,114,186,0.5)"
  const btnstyle = { margin: '8px 0' };

  const [state, setState] = useState({
    loading: false,
    ShowPass: false
  });
  const handleClickShowPassword = () => {
    setState({
      ...state,
      ShowPass: !state.ShowPass
    });
  };

  const [formValues, formHandle] = useForm({
    usuario: '',
    password: ''
  });

  const handleClick = () => {
    if (isFormValid()) {
      ValidateRecaptchaAndLogin();
    }
  };

  const isFormValid = () => {
    if (formValues.usuario.length === 0) {
      toast.error(t("msjValidation.usuarioObligatorio"));
      return false;
    } else
      if (formValues.password.length === 0) {
        toast.error(t("msjValidation.contrasenaObligatoria"));
        return false;
      } else {
        return true;
      }
  };

  const cargarGeolocalizacion = () => {
    if (!navigator.geolocation)
      alert("Este navegador no soporta la geolocalización"); else {
      const onUbicacionConcedida = (ubicacion) => {
        const coordenadas = ubicacion.coords;
        const latitud = coordenadas.latitude;
        const longitud = coordenadas.longitude;

        setLatitud(latitud);
        setLongitud(longitud);
      };

      const onErrorDeUbicacion = (error) => {
        let mensajeError;
        switch (error.code) {
          case 0:
            mensajeError = "Permiso denegado por el usuario.";
            break;
          case 1:
            mensajeError = "Posicion no disponible.";
            break;
          case 2:
            mensajeError = "Desconexion por tiempo.";
            break;
          case 3:
            mensajeError = "Error desconocido.";
            break;
        }
      };

      const opcionesDeSolicitud = {
        enableHighAccuracy: true, // Alta precisión
        maximumAge: 0, // sin cache
        timeout: 5000 // Esperar solo 5 segundos
      };

      navigator.geolocation.getCurrentPosition(onUbicacionConcedida, onErrorDeUbicacion, opcionesDeSolicitud);

    }
  };

  const Login = (recapthatoken) => {

    getUsuario({ variables: { usuario: formValues.usuario.toLowerCase(), clave: formValues.password, token: recapthatoken, ipUsuario: ipClient, pcUsuario: pcClient, longitud: longitud.toString(), latitud: latitud.toString() } });
  };

  const handleClose = () => {
    setOpen(false);
  };

  let componenteAceptar = "";
  if (textoTermino != "") {
    componenteAceptar = <TerminoAccept
      id="termino-accept"
      keepMounted
      open={open}
      onClose={handleClose}
      value={textoTermino}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      idtermino={idtermino}
      setTerminoFirmado={setTerminoFirmado}
      terminoFirmado={terminoFirmado} />;

  }  

  useEffect(() => {
    if (!dataLogin) return;

    if (dataLogin.login.success) {
      if (dataLogin.login.valorEsperado.valido) {
        const idUsuario = dataLogin.login.valorEsperado.usuario.idUsuario;
        const presetActivo = dataLogin.login.valorEsperado.usuario.presetActivo;
        sessionStorage.setItem('accessToken', dataLogin.login.valorEsperado.token);
        sessionStorage.setItem('accessTokenValidTo', dataLogin.login.valorEsperado.tokenValidTo);
        sessionStorage.setItem('idUsuario', idUsuario);
        sessionStorage.setItem('nombre', dataLogin.login.valorEsperado.usuario.nombre);
        sessionStorage.setItem('apellido', dataLogin.login.valorEsperado.usuario.apellido);
        sessionStorage.setItem('imagenPerfilDecode', dataLogin.login.valorEsperado.usuario.imagenPerfilDecode);
        sessionStorage.setItem('imagenPerfilTipo', dataLogin.login.valorEsperado.usuario.contentType);
        sessionStorage.setItem('presetUsuarioActivo', presetActivo);
        sessionStorage.setItem('usuario', formValues.usuario);
        sessionStorage.setItem('idTipoUsuario', dataLogin.login.valorEsperado.usuario.idTipoUsuario);

        cookies.set('idUsuario', idUsuario);
        cookies.set('accessToken', dataLogin.login.valorEsperado.token);

        setUser({ loggedIn: true });

        // verifico si firmó los Términos y Condiciones vigentes
        if (dataLogin.login.valorEsperado.usuario.terminoFirmado) {
          setOpen(false);
          setTerminoFirmado(true);
        } else {
          const texto = dataLogin.login.valorEsperado.usuario.terminoTexto;
          setTerminoFirmado(false);
          setTextoTermino(texto);
          if (texto != null && texto != "") {
            setIdtermino(dataLogin.login.valorEsperado.usuario.idTermino);
            setOpen(true);
          }
        }
      } else {
        setUser({ loggedIn: false });
        toast.error(dataLogin.login.error);
      }
    } else {
      setUser({ loggedIn: false });
      let descripcionError = GetDescripcionMensaje(dataLogin.login.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataLogin.login.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else {
        setMensajeError(dataLogin.login.error);
      }
    }
  }, [dataLogin]);

  useEffect(() => {
    if (!errorLogin) return;

    setUser({ loggedIn: false });
    setMensajeError("ERRORDB");
  }, [errorLogin]);

  // código para solucionar el problema del idioma automático
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        return child;
      }
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments);
    };
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      style={{
        minHeight: "100vh", backgroundColor: "rgb(210, 210, 210,0.3)",
        backgroundImage: `url(${fondo})`, backgroundRepeat: "no-repeat", backgroundBlendMode: "lighten", backgroundSize: "cover"
      }}
      zIndex="1">

      <ZoomAni in>
        <Paper elevation={10} style={paperStyle}>
          <Grid align='center'>
            <img src={logo} width='268px' />
          </Grid>
          <FormControl variant="outlined" fullWidth margin='dense'>
            <InputLabel htmlFor="outlined-adornment-user">{t("usuario")}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-user"
              name='usuario'
              label={t("usuario")}
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder={t("usuario")}
              value={formValues.usuario}
              onChange={formHandle}
              fullWidth
              required
              margin="dense" />

          </FormControl>
          <FormControl variant="outlined" fullWidth margin='dense'>
            <InputLabel htmlFor="outlined-adornment-password">{t("contrasena")}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              name='password'
              label={t("contrasena")}
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder={t("contrasena")}
              value={formValues.password}
              onChange={formHandle}
              onKeyDown={handleKeyDown}
              type={state.ShowPass ? 'text' : 'password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end">

                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>}
              fullWidth
              required
              margin="dense" />

          </FormControl>
          <Box sx={{ mt: 1, mx: 0.5 }}>
            <LoadingButton
              sx={{ backgroundColor: '#0063BE' }}
              loading={loading}
              loadingIndicator={t("ingresando")}
              style={btnstyle}
              variant="contained"
              onClick={handleClick}
              fullWidth>

              {t("ingresar")}
            </LoadingButton>
          </Box>
          <Box style={{ marginTop: "10px", display: 'flex', width: '100%', justifyContent: 'center' }}>
            <Link style={{ color: "#0063BE", fontWeight: 500, textDecoration: 'underline', fontSize: 14 }} to="/resetpass">
              {t("recuperarContrasena")}
            </Link>
          </Box>
        </Paper>
      </ZoomAni>


      {componenteAceptar}

      <ErrorDialog
        id="dlg-error-login"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />

    </Box>);


}

export default LoginView;